<template>
  <div id="dlg-disclosure">
    <NavBar :mainPage="false" />

    <!-- DLG Disclosure Section -->
    <section class="dlg-section" ref="dlgStart">
      <div class="content-wrapper">
        <h1 class="heading">DLG DISCLOSURE</h1>
        <p class="description">
          Default Loss Guarantee (DLG) Disclosure Details of Portfolio on which DLG has been provided as on
          <span v-html="lastDayOfPreviousMonth"></span>.
        </p>

        <div class="table-container">
          <table class="disclosure-table">
            <thead>
              <tr>
                <th>Portfolio</th>
                <th>Amount (In ₹ Cr)*</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in portfolios" :key="index">
                <td>{{ item.name }}</td>
                <td>{{ item.amount }}</td>
              </tr>
              <tr class="total-row">
                <td><strong>Total</strong></td>
                <td><strong>{{ totalAmount }}</strong></td>
              </tr>
            </tbody>
          </table>
          <p class="note">*Provisional</p>
        </div>
      </div>
    </section>

    
    <!-- Footer -->
    <section id="contact-footer" class="fullpage" v-lazy:background-image="require(`@/assets/background/footer_bg.png`)">
      <Footer id="foot" />
    </section>
  </div>
</template>

<script>
// import NavBar from "@/components/NavBar.vue";
// import Footer from "@/components/Footer.vue";

export default {
  name: "DLGDisclosure",
  components: {
    // NavBar,
    // Footer,
  },
  data() {
    return {
      portfolios: [
        { name: "Portfolio 1", amount: "7.08" }
      ]
    };
  },
  computed: {
    totalAmount() {
      return this.portfolios
        .reduce((sum, item) => sum + parseFloat(item.amount), 0)
        .toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
    },
    lastDayOfPreviousMonth() {
      const now = new Date();
      const firstDayOfCurrentMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      const lastDay = new Date(firstDayOfCurrentMonth - 1);

      const day = lastDay.getDate();
      const month = lastDay.toLocaleString("default", { month: "long" });
      const year = lastDay.getFullYear();
      const suffix = this.getDaySuffix(day);

      return `${day}<sup>${suffix}</sup> ${month}, ${year}`;
    }
  },
  methods: {
    getDaySuffix(day) {
      if (day >= 11 && day <= 13) return "th";
      switch (day % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
      }
    }
  },
  mounted() {
    this.$refs.dlgStart.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start"
    });
  },
  metaInfo() {
    return {
      link: [
        {
          rel: "canonical",
          href: "https://www.ftcash.com/dlg-disclosure"
        }
      ]
    };
  }
};
</script>

<style scoped>
#dlg-disclosure {
  overflow-y: hidden;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #333;
}
.note {
  margin-top: 1.5rem;
  font-size: 0.9rem;
  color: #666;
  font-style: "normal";
  text-align: left; /*ensures left alignment */
}
.dlg-section {
  padding: 3rem 1.5rem;
  background-color: #f4f6fe;
  min-height: 100vh;
  background-image: url("../assets/background/contact_form_bg.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.content-wrapper {
  max-width: 1000px;
  margin: auto;
  background-color: rgba(255, 255, 255, 0.95);
  padding: 2rem;
  border-radius: 8px;
}

.heading {
  color: #1c2b6c;
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  text-align: left;
}

.description {
  font-size: 1.1rem;
  margin-bottom: 2rem;
  line-height: 1.6;
  text-align: left;
}

.table-container {
  overflow-x: auto;
  background: white;
  padding: 1rem;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.disclosure-table {
  width: 100%;
  border-collapse: collapse;
}

.disclosure-table th,
.disclosure-table td {
  text-align: left;
  padding: 12px 16px;
  border-bottom: 1px solid #ccc;
}

.disclosure-table th {
  background-color: #e8ecf9;
  font-weight: 600;
}

.total-row td {
  font-weight: bold;
  background-color: #f1f3f9;
}

.note {
  margin-top: 1.5rem;
  font-size: 0.9rem;
  color: #666;
  font-style: normal;
}

/* Responsive Fixes */
@media (max-width: 600px) {
  .heading {
    font-size: 1.8rem;
  }

  .description {
    font-size: 1rem;
  }

  .disclosure-table th,
  .disclosure-table td {
    padding: 10px;
    font-size: 0.9rem;
  }
}
</style>
